import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Grid,
  TextField,
  Typography,
  Button,
  CircularProgress,
} from "@material-ui/core";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import TSCheckResultGraphs from "./TSCheckResultGraphs";
import { selectImageToken, selectUser } from "../../../features/userSlice";
import { openWebSite } from "../../../apis/util";
import { postRequest } from "../../../apis/axiosAction";
import {
  getTSCheckData,
  TS_CHECK_DATA,
  TS_CHECK_BIG_RECORD,
  TS_CHECK_ADD_BIG_RECORD,
  TS_CHECK_RECORD,
} from "./TSCheckTableDataOperation";
import { DateTime } from "luxon";
import {
  getFixedFlg,
  setFixedFlg,
  setInitTenpoCode,
} from "../../Header/Header";
import { stylesTSCheckTable } from "./StylesTSCheckRegister";
import { setLastTSCheckId, setTSCheckId } from "../Register/TSCheck";
import { userLogging } from "../../../apis/userLog";
import TSCheckDialog from "../TSCheckDialog";
import { isOfcCheck, getJobCategoryFromCode } from "../../../apis/privilege";

let pdfFlg = false;
export { pdfFlg };
let updateFlg = 0;

const buttonNamePrint = "印刷（PDFダウンロード）";
const buttonNameExcute = "登録（PDF作成）";
const OTHER_VALUE: string = "99";
export function commentReason(row: TS_CHECK_RECORD) {
  let comment = "";
  const addComment = (
    row: TS_CHECK_RECORD,
    target: string,
    comment: string
  ) => {
    let workComment = "";
    if (row.reason_target_list && target) {
      for (let i = 0; i < row.reason_target_list.length; i++) {
        if (target === row.reason_target_list[i].value) {
          workComment += row.reason_target_list[i].name + " ";
        }
      }
    }
    if (OTHER_VALUE === target) {
      workComment += "その他 ";
    }
    if (row.reason_comment_list && comment) {
      for (let i = 0; i < row.reason_comment_list.length; i++) {
        if (comment === row.reason_comment_list[i].value) {
          workComment += row.reason_comment_list[i].name + " ";
        }
      }
    }
    return workComment;
  };

  comment += addComment(row, row.user_radio_target, row.user_radio_comment);
  if (row.user_ng_list) {
    for (let i = 0; i < row.user_ng_list.length; i++) {
      comment += addComment(
        row,
        row.user_ng_list[i].user_radio_target,
        row.user_ng_list[i].user_radio_comment
      );
    }
  }

  return comment;
}

// 天候リスト
const weatherList = [
  { name: "晴れ", code: "1" },
  { name: "曇り", code: "2" },
  { name: "雨", code: "3" },
  { name: "雪", code: "4" },
];

// 曜日の取得
const getDayOfWeekText = (datetime: DateTime | null) => {
  if (!datetime) {
    return;
  }
  let weekDayArray: string[] = [];
  weekDayArray = ["月", "火", "水", "木", "金", "土", "日"];
  const dayOfWeek = datetime.weekday;
  return weekDayArray[dayOfWeek - 1];
};

const TSCheckResultPrint: React.FC<{
  tenpoCode: string;
  tsCheckId: string;
  lastTSCheckId: string;
  setUpdateFlg: any;
}> = ({ tenpoCode, tsCheckId, lastTSCheckId, setUpdateFlg }) => {
  const user = useSelector(selectUser);
  const [rowItemList, setRowItemList] = React.useState<TS_CHECK_BIG_RECORD[]>(
    []
  );
  const [addRowItemList, setAddRowItemList] = React.useState<
    TS_CHECK_ADD_BIG_RECORD[]
  >([]);
  const classes = stylesTSCheckTable();
  const [approvalDate, setApprovalDate] = React.useState<DateTime | null>(
    DateTime.local()
  );
  const [convertedApprovalDate, setConvertedApprovalDate] = React.useState<
    string | null
  >(null);
  const [newPdfURL, setNewPdfURL] = React.useState("");
  const [pdfNewButtonName, setPdfNewButtonName] =
    React.useState(buttonNameExcute);
  const [click, setClick] = React.useState(false);
  const [creatWait, setCreatWait] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [alertFlg, setAlertFlg] = React.useState(false);
  const [dialogFlg, setDialogFlg] = React.useState(false);
  const [dialogNum, setDialogNum] = React.useState(0);
  const [approveWeatherName, setApproveWeatherName] = React.useState("");
  const [approveHour, setApproveHour] = React.useState("");

  // 法定検査実施日
  const [inspectionDate, setInspectionDate] = React.useState<DateTime | null>(
    DateTime.local()
  );
  // 点検結果確認日
  const [confirmationDate, setConfirmationDate] = React.useState<DateTime | null>(
    DateTime.local()
  );
  // 浄化槽有無
  const [septicTankValue, setSepticTankValue] = React.useState("");
  // 法定検査状況
  const [inspectionValue, setInspectionValue] = React.useState("");
  // 点検結果状況
  const [confirmationValue, setConfirmationValue] = React.useState("");

  // ダイアログ表示
  const dialogCancel = () => {
    if (dialogNum === 2) {
      setPdfNewButtonName(buttonNameExcute);
      setCreatWait(false);
      handleClick();
      setLoading(false);
    }
    setDialogFlg(false);
  };
  const dialogOK = () => {
    if (!alertFlg) {
      if (dialogNum === 1) {
        setPdfNewButtonName("PDF作成中…");
        setCreatWait(true);
        handlePdfPrint();
      } else if (dialogNum === 2) {
        pdfPrintUpdate();
      }
    }
    setDialogFlg(false);
  };

  const handleClick = () => {
    setClick((prev) => !click);
  };

  function checkInputTSCheck() {
    let result = true;
    for (let i = 0; i < rowItemList.length; i++) {
      for (let j = 0; j < rowItemList[i].rows.length; j++) {
        if (
          !rowItemList[i].rows[j].button_value ||
          rowItemList[i].rows[j].button_value === "0"
        ) {
          result = false;
        }
      }
    }
    for (let i = 0; i < addRowItemList.length; i++) {
      for (let j = 0; j < addRowItemList[i].rows.length; j++) {
        if (
          !addRowItemList[i].rows[j].button_value ||
          addRowItemList[i].rows[j].button_value === "0"
        ) {
          result = false;
        }
      }
    }
    return result;
  }

  const history = useHistory();
  function clickReference(
    tenpoCode: string,
    tsCheckId: string,
    lastTSCheckId: string
  ) {
    setFixedFlg(true);
    setLastTSCheckId(lastTSCheckId);
    setTSCheckId(tsCheckId);
    setInitTenpoCode(tenpoCode);
    // 画面遷移
    history.push("ts-check");
  }

  /**
   * PDFボタン押下時のイベント
   * @param type:number 1:新方式 2:旧方式
   */
  function clickPdfPrint(type: number) {
    if (creatWait) {
      return;
    }
    if (type === 1 && newPdfURL) {
      openWebSite(pdfURL(true));
      return;
    }
    if (!checkInputTSCheck()) {
      setAlertFlg(true);
      setDialogMessage([
        "未入力項目があります。",
        "入力内容を確認してください",
      ]);
      setDialogFlg(true);
      return;
    }
    if (
      !septicTankValue || septicTankValue === "0" ||
      !inspectionValue || inspectionValue === "0" ||
      !confirmationValue || confirmationValue === "0"
    ) {
      setAlertFlg(true);
      setDialogMessage([
        "浄化槽のチェック項目に未入力がありますので確認してください。",
      ]);
      setDialogFlg(true);
      return;
    }
    if (!convertedApprovalDate) {
      setAlertFlg(true);
      setDialogMessage(["作成日を入力してください"]); // 旧承認日
      setDialogFlg(true);
      return;
    }
    if (!approveHour) {
      setAlertFlg(true);
      setDialogMessage(["作成時間を入力してください"]);
      setDialogFlg(true);
      return;
    }

    if (getFixedFlg()) {
      setPdfNewButtonName("PDF作成中…");
      setCreatWait(true);
      handlePdfPrint();
    } else {
      setAlertFlg(false);
      setDialogNum(1);
      setDialogMessage([
        "作成日 " +
          (approvalDate ? approvalDate.toFormat("yyyy年MM月dd日") : "") +
          " でPDF作成します。",
        "PDFの出力後に編集は行えません。",
        "よろしいですか？",
      ]);
      setDialogFlg(true);
      return;
    }
  }

  // 入力値比較
  const checkLatestRecord = (base: any[], check: any[]) => {
    for (let i = 0; i < base.length; i++) {
      if (base[i].rows.length !== check[i].rows.length) {
        return false;
      }
      for (let j = 0; j < base[i].rows.length; j++) {
        let baseRow = base[i].rows[j];
        let checkRow = check[i].rows[j];
        if (
          baseRow.big_item_id !== checkRow.big_item_id ||
          baseRow.button_value !== checkRow.button_value ||
          baseRow.score !== checkRow.score ||
          baseRow.user_input_comment !== checkRow.user_input_comment ||
          baseRow.user_radio_comment !== checkRow.user_radio_comment ||
          baseRow.user_radio_target !== checkRow.user_radio_target ||
          baseRow.small_item_id !== checkRow.small_item_id ||
          baseRow.small_title !== checkRow.small_title
        ) {
          return false;
        }
        for (let k = 0; k < baseRow.photo_filepath_gcs.length; k++) {
          if (
            baseRow.photo_filepath_gcs[k] !== checkRow.photo_filepath_gcs[k]
          ) {
            return false;
          }
        }
      }
    }
    return true;
  };

  const handlePdfPrint = async () => {
    setLoading(true);
    let ofcFlg = false;
    if (isOfcCheck(user, tenpoCode)) {
      ofcFlg = true;
    }
    await getTSCheckData(
      tenpoCode,
      tsCheckId,
      lastTSCheckId,
      getFixedFlg(),
      getJobCategoryFromCode(user),
      ofcFlg
    ).then((res: TS_CHECK_DATA) => {
      let ckRowItemList: TS_CHECK_BIG_RECORD[] = res.base_value;
      let ckAddRowItemList: TS_CHECK_ADD_BIG_RECORD[] = res.add_value;

      // 画面の最新状態との比較
      if (
        convertedApprovalDate !== res.approve_day ||
        !checkLatestRecord(rowItemList, ckRowItemList) ||
        !checkLatestRecord(addRowItemList, ckAddRowItemList)
      ) {
        setPdfNewButtonName(buttonNameExcute);
        setCreatWait(false);
        handleClick();
        setLoading(false);
        setAlertFlg(true);
        setDialogNum(3);
        setDialogMessage([
          "他の画面から内容が変更されています。",
          "一度画面を閉じてから再度、当該店舗の情報を開いて",
          "内容を確認の上、提出してください。",
        ]);
        setDialogFlg(true);
        return;
      } else {
        // 次回の店舗衛生点検表のデータを作成
        const apiParams = {
          id: tsCheckId,
          approve_day: convertedApprovalDate,
          newFlag: true,
        };
        const url = process.env.REACT_APP_API_URL_J11SPB22 + "tscheck/data-phase2";
        setCreatWait(true);
        postRequest(url, apiParams)
          .then(async (res) => {
            // 同一店舗同一週有りの場合、上書きの確認メッセージ表示
            if (res.data.dataList[0] === "SameStoreSameMonth") {
              setLoading(false);
              setCreatWait(false);
              setAlertFlg(false);
              setDialogNum(2);
              setDialogMessage(["上書き保存されますがよろしいですか？"]);
              setDialogFlg(true);
              return;
            }
            // 完了済みのレコードの場合
            else if (res.data.dataList[0] === "AlreadyCompleted") {
              setPdfNewButtonName(buttonNameExcute);
              setCreatWait(false);
              handleClick();
              setLoading(false);
              setAlertFlg(true);
              setDialogNum(3);
              setDialogMessage([
                "既に登録されています。",
                "新たにデータ登録する場合は左上のメニューから「新規作成」を、",
                "作成されたデータを見る場合は左上のメニューからデータ検索してください。",
              ]);
              setDialogFlg(true);
              return;
            }
            // Firestoreへの入力内容に不備がある場合
            else if (res.data.dataList[0] === "InvalidFirestoreSave") {
              setPdfNewButtonName(buttonNameExcute);
              setCreatWait(false);
              handleClick();
              setLoading(false);
              setAlertFlg(true);
              setDialogNum(3);
              setDialogMessage([
                "入力内容が正常に保存できませんでした。",
                "メニューより「新規作成」を開き、対象店舗を選択して再度登録を実施してください。",
              ]);
              setDialogFlg(true);
              return;
            }
            else if (res.data.dataList[0] === "PdfCreationError") {
              setPdfNewButtonName(buttonNameExcute);
              setCreatWait(false);
              handleClick();
              setLoading(false);
              setAlertFlg(true);
              setDialogNum(3);
              setDialogMessage([
                "帳票作成に失敗しました。",
                "メニューより「新規作成」を開き、対象店舗を選択して再度登録を実施してください。",
              ]);
              setDialogFlg(true);
              return;
            }
            // 新規作成の場合の処理（同一店舗同一週無し）
            setNewPdfURL(pdfURL(true));
            setPdfNewButtonName(buttonNamePrint);
            setCreatWait(false);
            handleClick();
            setLoading(false);
            updateFlg++;
            setUpdateFlg(updateFlg);
            clickReference(tenpoCode, tsCheckId, lastTSCheckId);
          })
          .catch((r) => {
            setCreatWait(false);
            setLoading(false);
            setAlertFlg(true);
            setDialogMessage([String(r)]);
            setDialogFlg(true);
          });
      }
    });
  };

  const pdfPrintUpdate = async () => {
    setLoading(true);
    setCreatWait(true);
    const url = process.env.REACT_APP_API_URL_J11SPB22 + "tscheck/data-phase2";
    const apiParams2 = {
      id: tsCheckId,
      approve_day: convertedApprovalDate,
      newFlag: false,
    };
    await postRequest(url, apiParams2)
      .then((res2) => {
        if (res2.data.dataList[0] === "PdfCreationError") {
          setPdfNewButtonName(buttonNameExcute);
          setCreatWait(false);
          handleClick();
          setLoading(false);
          setAlertFlg(true);
          setDialogNum(3);
          setDialogMessage([
            "帳票作成に失敗しました。",
            "メニューより「新規作成」を開き、対象店舗を選択して再度登録を実施してください。",
          ]);
          setDialogFlg(true);
          return;
        }
        setNewPdfURL(pdfURL(true));
        setPdfNewButtonName(buttonNamePrint);
        setCreatWait(false);
        handleClick();
        setLoading(false);
        updateFlg++;
        setUpdateFlg(updateFlg);
        clickReference(tenpoCode, tsCheckId, lastTSCheckId);
      })
      .catch((r) => {
        setCreatWait(false);
        setLoading(false);
        setAlertFlg(true);
        setDialogMessage([String(r)]);
        setDialogFlg(true);
      });
    // 処理を終了する
    return;
  };

  const imageToken = useSelector(selectImageToken);
  function getImageFile(imagePath: string) {
    if (imagePath === undefined || imagePath === "") {
      return "";
    }
    return (
      process.env.REACT_APP_CLOUD_STORAGE_URL +
      imagePath +
      "?access_token=" +
      imageToken
    );
  }

  function pdfURL(isNewFormat: boolean) {
    const pdfDir = process.env.REACT_APP_GCS_DIR_PDF
      ? process.env.REACT_APP_GCS_DIR_PDF + "/"
      : "pdftest/";
    let suffix = "_old.pdf";
    if (isNewFormat) {
      suffix = "_ts.pdf";
    }
    return (
      process.env.REACT_APP_CLOUD_STORAGE_URL +
      pdfDir +
      tsCheckId +
      suffix +
      "?access_token=" +
      imageToken
    );
  }

  useEffect(() => {
    setNewPdfURL("");
    setPdfNewButtonName(buttonNameExcute);
  }, [tenpoCode]);

  useEffect(() => {
    setApprovalDate(null);
    setConvertedApprovalDate("");
    setInspectionDate(null);
    setConfirmationDate(null);
    setLoading(true);
    userLogging("店舗衛生点検表", "印刷#初期表示", tsCheckId);
    let ofcFlg = false;
    if (isOfcCheck(user, tenpoCode)) {
      ofcFlg = true;
    }
    getTSCheckData(
      tenpoCode,
      tsCheckId,
      lastTSCheckId,
      getFixedFlg(),
      getJobCategoryFromCode(user),
      ofcFlg
    ).then((res: TS_CHECK_DATA) => {
      setApprovalDate(
        res.approve_day
          ? DateTime.fromFormat(res.approve_day, "yyyyMMdd")
          : null
      );
      for (const weather of weatherList) {
        if (weather.code === res.approve_weather) {
          setApproveWeatherName(weather.name);
          break;
        }
      }
      if (res.approve_hour) {
        setApproveHour(res.approve_hour);
      }
      setConvertedApprovalDate(res.approve_day);
      setSepticTankValue(res.septic_tank_value);
      setInspectionDate(
        res.inspection_day
          ? DateTime.fromFormat(res.inspection_day, "yyyyMMdd")
          : null
      );
      setInspectionValue(res.inspection_value);
      setConfirmationDate(
        res.confirmation_day
          ? DateTime.fromFormat(res.confirmation_day, "yyyyMMdd")
          : null
      );
      setConfirmationValue(res.confirmation_value);
      setRowItemList(res.base_value);
      setAddRowItemList(res.add_value);
      if (getFixedFlg()) {
        setNewPdfURL(pdfURL(true));
        setPdfNewButtonName(buttonNamePrint);
      }
      setLoading(false);
    });
  }, [tsCheckId]);

  // 添付写真が存在するか判定
  const existsPhoto = (photoFilePath: Array<any>): boolean => {
    return photoFilePath[0] !== undefined && photoFilePath[0] !== "";
  };

  // 添付コメントが存在するか判定
  const existsComment = (row: TS_CHECK_RECORD): boolean => {
    if (row.comment_handwrite_flag && row.comment_handwrite_flag === "1") {
      return (
        row.comment_filepath_gcs !== undefined &&
        row.comment_filepath_gcs[0] !== undefined &&
        row.comment_filepath_gcs[0] !== ""
      );
    } else {
      return (
        row.user_input_comment !== undefined && row.user_input_comment !== ""
      );
    }
  };

  // NG理由が存在するか判定
  const existsCommentReason = (row: TS_CHECK_RECORD): boolean => {
    const cReason = commentReason(row);
    return cReason !== undefined && cReason !== "";
  };

  function getCheckRecord(rowItem: any, index: number) {
    return (
      <>
        {Object.keys(rowItem.rows).length !== 0 ? (
          <>
            <Grid item xs={12}>
              <Typography variant="h6" className={classes.header}>
                {rowItem.big_title}
              </Typography>
            </Grid>
            {rowItem.rows.map((row: any, indexRowItem: number) => (
              <>
              <Grid container>
                <Typography gutterBottom>
                  判定：
                  {row.button_value === "1"
                    ? "◯"
                    : row.button_value === "2"
                    ? "✕"
                    : "--"}
                  ：{row.small_title}
                </Typography>
              </Grid>
              <Grid container>
                <Grid item lg={2} md={4} sm={4}>
                  {existsPhoto(row.photo_filepath_gcs) ||
                  existsComment(row) ||
                  existsCommentReason(row) ? (
                    getImageFile(row.photo_filepath_gcs[0]) ? (
                      <img
                        src={getImageFile(row.photo_filepath_gcs[0])}
                        alt={row.small_title}
                        height="200"
                        style={{
                          width: "200px",
                          WebkitAppearance: "none",
                        }}
                      />
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item lg={10} md={8} sm={8}>
                  {existsCommentReason(row) ? (
                    <Grid item className={classes.commentGrid}>
                      <TextField
                        fullWidth
                        label="指摘ポイント"
                        id="outlined-multiline-static"
                        aria-label="store-input-comment-area"
                        multiline
                        value={commentReason(row)}
                        variant="outlined"
                        inputProps={{
                          readOnly: true,
                        }}
                        className={classes.commentText}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                  {existsComment(row) ? (
                    <Grid item className={classes.commentGrid}>
                      {!row.comment_handwrite_flag ||
                      row.comment_handwrite_flag !== "1" ? (
                        <TextField
                          fullWidth
                          label="コメント"
                          id="outlined-multiline-static"
                          aria-label="store-input-comment-area"
                          multiline
                          value={row.user_input_comment}
                          variant="outlined"
                          inputProps={{
                            readOnly: true,
                          }}
                          className={classes.commentText}
                        />
                      ) : getImageFile(row.comment_filepath_gcs[0]) ? (
                        <img
                          src={getImageFile(row.comment_filepath_gcs[0])}
                          alt={row.small_title}
                          height="200"
                          style={{
                            width: "200px",
                            WebkitAppearance: "none",
                            border: "1px solid",
                            borderColor: "black",
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </Grid>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              </>
            ))}
          </>
        ) : (
          ""
        )}
      </>
    );
  }

  const getSepticTank = (() => {
    return (
      <>
      <Grid item xs={12}>
        <Typography variant="h6" className={classes.header}>浄化槽</Typography>
      </Grid>
      <Grid container>
        <Typography gutterBottom>
          判定：
          {septicTankValue === "1"
            ? "◯"
            : septicTankValue === "2"
            ? "✕"
            : "--"}
          ：浄化槽の設置状況を選択してください。
        </Typography>
      </Grid>
      <Grid container>
        <Typography gutterBottom>
          判定：
          {inspectionValue === "1"
            ? "◯"
            : inspectionValue === "2"
            ? "✕"
            : "--"}
          ：本年度の法定点検（11条）の実施状況と点検実施日を入力してください。
          {inspectionDate ? (
              "　検査実施日：" +
              inspectionDate.toFormat("yyyy/MM/dd") +
              "(" +
              getDayOfWeekText(inspectionDate) +
              ")"
            ) : <></>
          }
        </Typography>
      </Grid>
      <Grid container>
        <Typography gutterBottom>
          判定：
          {confirmationValue === "1"
            ? "◯"
            : confirmationValue === "2"
            ? "✕"
            : "--"}
          ：検査結果報告書の内容をもとに、総合判定結果を選択してください。
          {confirmationDate ? (
              "　結果確認日：" +
              confirmationDate.toFormat("yyyy/MM/dd") +
              "(" +
              getDayOfWeekText(confirmationDate) +
              ")"
            ) : <></>
          }
        </Typography>
      </Grid>
      </>
    )
  });

  return (
    <>
      <Grid container className={classes.contentFrame}>
        <Grid container justify="center" alignItems="center">
          {loading && <div className={classes.overLayer}></div>}
          {loading && (
            <CircularProgress className={classes.circularProgress} size={120} />
          )}
          <Grid item xs={7}>
            <Grid container justify="flex-end" alignItems="center">
              <Typography variant="h6">作成日</Typography>
            </Grid>
          </Grid>
          <Grid item xs={5}>
            <Grid container justify="center" alignItems="center">
              {approvalDate ? (
                <Typography variant="h6">
                  {approvalDate.toFormat("yyyy年MM月dd日") +
                    "(" +
                    getDayOfWeekText(approvalDate) +
                    ") " +
                    approveHour +
                    (approveHour ? "時 " : " ") +
                    approveWeatherName}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid container justify="center">
          <TSCheckResultGraphs
            tenpoCode={tenpoCode}
            tsCheckId={tsCheckId}
            lastTSCheckId={lastTSCheckId}
          />
        </Grid>
        <Grid container justify="center">
          {/* 2.カテゴリ別 確認状況↑ここまで */}
          {/* 項目↓ここから */}
          {rowItemList.map((rowItem, index) => getCheckRecord(rowItem, index))}
          {/* 項目↑ここまで */}
          {/* 追加項目↓ここから */}
          {addRowItemList.map((rowItem, index) =>
            getCheckRecord(rowItem, index)
          )}
          {getSepticTank()}
          {/* 追加項目↑ここまで */}
        </Grid>
      </Grid>
      <Grid container justify="center" alignItems="center">
        <Button
          variant="contained"
          className={classes.button}
          onClick={() => {
            userLogging("店舗衛生点検表", "印刷#帳票出力", "");
            clickPdfPrint(1);
          }}
        >
          {pdfNewButtonName}
          {newPdfURL ? <DownloadIcon /> : ""}
        </Button>
      </Grid>

      {/* ダイアログ */}
      <TSCheckDialog
        msg={dialogMessage}
        isOpen={dialogFlg}
        doOK={dialogOK}
        doNo={dialogCancel}
        isAlert={alertFlg}
      />
    </>
  );
};

export default TSCheckResultPrint;
